<div *ngIf="accidentDetail">
  <app-prime-loader
    *ngIf="_retrySubmitLoading$ | async"
    text=""
  ></app-prime-loader>
  <div class="button-process-container">
    <button
      *ngIf="!!submitClaimantsSAPFailedOrWaiting"
      [disabled]="
        accidentDetail.estadoDeProceso == estadoReclamantesSAP.FALLIDO
      "
      (click)="retrySubmitSAPClaimants()"
      class="button button-blue page-top-bar"
    >
      Reprocesar reclamantes
      <i class="fas fa-sync-alt"></i>
    </button>
  </div>
  <div *ngFor="let v of vehiculos" class="div-form">
    <div class="collapsible-container">
      <span (click)="activateTab(v)" [class.active]="v.activeTab"
        ><strong>Vehículo</strong> - {{ v.patente }}
        <i *ngIf="v.activeTab" class="fas fa-chevron-up"></i
        ><i *ngIf="!v.activeTab" class="fas fa-chevron-down"></i>
        <span
          class="claimants-status-label"
          [class.procesando]="
            v.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.PROCESANDO.toLowerCase()
          "
          [class.ingresado-sap]="
            v.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.INGRESADO_SAP.toLowerCase()
          "
          [class.en-espera]="
            v.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.EN_ESPERA.toLowerCase()
          "
          [class.fallido]="
            v.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.FALLIDO.toLowerCase()
          "
          >{{ v.estadoDeProceso }}</span
        ></span
      >
      <div class="collapsible-content" *ngIf="v.activeTab">
        <div *ngIf="!!v.errorProcesamiento" class="error-alert-container">
          <div class="alert alert-danger">
            <label>{{ v.errorProcesamiento }}</label>
          </div>
        </div>
        <div class="grid-col-3">
          <!-- Nivel de danio/lesion -->
          <div class="input-container">
            <span class="label">Nivel de daño/lesión</span>
            <div class="input">
              <input
                value="{{ v.nivelDanio }}"
                type="text"
                placeholder="Nivel de daño/lesión"
              />
            </div>
          </div>
          <!-- Figura -->
          <div class="input-container">
            <span class="label">Figura</span>
            <div class="input">
              <input value="{{ v.figura }}" type="text" placeholder="Figura" />
            </div>
          </div>
        </div>
        <!-- Comentarios -->
        <div class="input-container">
          <span class="label">Comentarios</span>
          <div class="input">
            <textarea
              value="{{ v.comentarios }}"
              placeholder="Comentarios"
            ></textarea>
          </div>
        </div>

        <div class="grid-col-3">
          <!-- Nombre -->
          <div class="input-container">
            <span class="label">Nombre</span>
            <div class="input">
              <input value="{{ v.nombre }}" type="text" placeholder="Nombre" />
            </div>
          </div>
          <!-- Apellido -->
          <div class="input-container">
            <span class="label">Apellido</span>
            <div class="input">
              <input
                value="{{ v.apellido }}"
                type="text"
                placeholder="Apellido"
              />
            </div>
          </div>
          <!-- Tipo documento -->
          <div class="input-container">
            <span class="label">Tipo documento</span>
            <div class="input">
              <input
                value="{{ v.tipoDocumento }}"
                type="text"
                placeholder="Tipo documento"
              />
            </div>
          </div>
          <!-- Nro Documento -->
          <div class="input-container">
            <span class="label">Nro Documento</span>
            <div class="input">
              <input
                value="{{ v.nroDocumento }}"
                type="text"
                placeholder="Nro Documento"
              />
            </div>
          </div>
          <!-- Reclamante -->
          <div class="input-container">
            <span class="label">Reclamante</span>
            <div class="input">
              <input
                value="{{ v.reclamante }}"
                type="text"
                placeholder="Reclamante"
              />
            </div>
          </div>
          <!-- Damnificado -->
          <div class="input-container">
            <span class="label">Damnificado</span>
            <div class="input">
              <input
                value="{{ v.damnificado }}"
                type="text"
                placeholder="Damnificado"
              />
            </div>
          </div>
          <!-- Tercero transporte -->
          <div class="input-container">
            <span class="label">Tercero transporte</span>
            <div class="input">
              <input
                value="{{ v.tercero }}"
                type="text"
                placeholder="Tercero transporte"
              />
            </div>
          </div>
          <!-- Descripcion del daño -->
          <div class="input-container textarea">
            <span class="label">Descripción del daño</span>
            <div class="input">
              <textarea
                value="{{ v.descripcion }}"
                placeholder="Descripción del daño"
              ></textarea>
            </div>
          </div>
          <!-- Detalle de archivos -->
          <div class="input-container textarea">
            <span class="label">Detalle de archivos</span>
            <div class="input">
              <textarea
                value="{{ v.detalleArchivos }}"
                placeholder="Detalle de archivos"
              ></textarea>
            </div>
          </div>
          <!-- Test de alcoholemia -->
          <div class="input-container">
            <span class="label">Test de alcoholemia</span>
            <div class="input">
              <input
                value="{{ v.testAlcoholemia }}"
                type="text"
                placeholder="Test de alcoholemia"
              />
            </div>
          </div>
          <!-- Compania del tercero -->
          <div class="input-container">
            <span class="label">Compañía del tercero</span>
            <div class="input">
              <input
                value="{{ v.companiaTercero }}"
                type="text"
                placeholder="Compañía del tercero"
              />
            </div>
          </div>
          <!-- Ramo del tercero damnificado -->
          <div class="input-container">
            <span class="label">Ramo del tercero damnificado</span>
            <div class="input">
              <input
                value="{{ v.ramoTerceroDamnificado }}"
                type="text"
                placeholder="Ramo del tercero damnificado"
              />
            </div>
          </div>
          <!-- Tipo de patente -->
          <div class="input-container">
            <span class="label">Tipo de patente</span>
            <div class="input">
              <input
                value="{{ v.tipoPatente }}"
                type="text"
                placeholder="Tipo de patente"
              />
            </div>
          </div>
          <!-- Patente -->
          <div class="input-container">
            <span class="label">Patente</span>
            <div class="input">
              <input
                value="{{ v.patente }}"
                type="text"
                placeholder="Patente"
              />
            </div>
          </div>
          <!-- Motor -->
          <div class="input-container">
            <span class="label">Motor</span>
            <div class="input">
              <input value="{{ v.motor }}" type="text" placeholder="Motor" />
            </div>
          </div>
          <!-- Chasis -->
          <div class="input-container">
            <span class="label">Chasis</span>
            <div class="input">
              <input value="{{ v.chasis }}" type="text" placeholder="Chasis" />
            </div>
          </div>
          <!-- Vehículo -->
          <div class="input-container">
            <span class="label">Vehículo</span>
            <div class="input">
              <input
                value="{{ v.vehiculo }}"
                type="text"
                placeholder="Vehiculo"
              />
            </div>
          </div>
          <!-- Anio -->
          <div class="input-container">
            <span class="label">Año</span>
            <div class="input">
              <input value="{{ v.anio }}" type="text" placeholder="Año" />
            </div>
          </div>
          <!-- Color -->
          <div class="input-container">
            <span class="label">Color</span>
            <div class="input">
              <input value="{{ v.color }}" type="text" placeholder="Color" />
            </div>
          </div>
          <!-- Situación del vehículo -->
          <div class="input-container">
            <span class="label">Situación del vehículo</span>
            <div class="input">
              <input
                value="{{ v.situacion }}"
                type="text"
                placeholder="Situación del vehículo"
              />
            </div>
          </div>
          <!-- Ubicación del impacto -->
          <div class="input-container">
            <span class="label">Ubicación del impacto</span>
            <div class="input">
              <input
                value="{{ v.ubicacionImpacto }}"
                type="text"
                placeholder="Ubicación del impacto"
              />
            </div>
          </div>
          <!-- Direccion del tercero -->
          <div class="input-container">
            <span class="label">Dirección del tercero</span>
            <div class="input">
              <input
                value="{{ v.direccionTercero }}"
                type="text"
                placeholder="Dirección del tercero"
              />
            </div>
          </div>
          <!-- Telefono del tercero -->
          <div class="input-container">
            <span class="label">Teléfono del tercero</span>
            <div class="input">
              <input
                value="{{ v.telefonoTercero }}"
                type="text"
                placeholder="Teléfono del tercero"
              />
            </div>
          </div>
          <!-- Numero libreta -->
          <div class="input-container">
            <span class="label">Número libreta</span>
            <div class="input">
              <input
                value="{{ v.numeroLibreta }}"
                type="text"
                placeholder="Número libreta"
              />
            </div>
          </div>
          <!-- Departamento libreta -->
          <div class="input-container">
            <span class="label">Departamento libreta</span>
            <div class="input">
              <input
                value="{{ v.departamentoLibreta }}"
                type="text"
                placeholder="Departamento libreta"
              />
            </div>
          </div>
          <!-- Vencimiento libreta -->
          <div class="input-container">
            <span class="label">Vencimiento libreta</span>
            <div class="input">
              <input
                value="{{ v.vencimientoLibreta }}"
                type="text"
                placeholder="Vencimiento libreta"
              />
              <i class="fas fa-calendar-alt"></i>
            </div>
          </div>
          <!-- Categoría libreta -->
          <div class="input-container">
            <span class="label">Categoría libreta</span>
            <div class="input">
              <input
                value="{{ v.categoriaLibreta }}"
                type="text"
                placeholder="Categoría libreta"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let c of cosas" class="div-form">
    <div class="collapsible-container">
      <span (click)="activateTab(c)" [class.active]="c.activeTab"
        ><strong>Cosa</strong> - {{ c.nombre
        }}<i *ngIf="c.activeTab" class="fas fa-chevron-up"></i
        ><i *ngIf="!c.activeTab" class="fas fa-chevron-down"></i>
        <span
          class="claimants-status-label"
          [class.procesando]="
            c.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.PROCESANDO.toLowerCase()
          "
          [class.ingresado-sap]="
            c.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.INGRESADO_SAP.toLowerCase()
          "
          [class.en-espera]="
            c.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.EN_ESPERA.toLowerCase()
          "
          [class.fallido]="
            c.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.FALLIDO.toLowerCase()
          "
          >{{ c.estadoDeProceso }}</span
        >
      </span>
      <div class="collapsible-content" *ngIf="c.activeTab">
        <div *ngIf="!!c.errorProcesamiento" class="error-alert-container">
          <div class="alert alert-danger">
            <label>{{ c.errorProcesamiento }}</label>
          </div>
        </div>
        <div class="grid-col-3">
          <!-- Nivel de danio/lesion -->
          <div class="input-container">
            <span class="label">Nivel de daño/lesión</span>
            <div class="input">
              <input
                value="{{ c.nivelDanio }}"
                type="text"
                placeholder="Nivel de daño/lesión"
              />
            </div>
          </div>
          <!-- Figura -->
          <div class="input-container">
            <span class="label">Figura</span>
            <div class="input">
              <input value="{{ c.figura }}" type="text" placeholder="Figura" />
            </div>
          </div>
        </div>
        <!-- Comentarios -->
        <div class="input-container">
          <span class="label">Comentarios</span>
          <div class="input">
            <textarea
              value="{{ c.comentarios }}"
              placeholder="Comentarios"
            ></textarea>
          </div>
        </div>
        <div class="grid-col-3">
          <!-- Nombre -->
          <div class="input-container">
            <span class="label">Nombre</span>
            <div class="input">
              <input value="{{ c.nombre }}" type="text" placeholder="Nombre" />
            </div>
          </div>
          <!-- Apellido -->
          <div class="input-container">
            <span class="label">Apellido</span>
            <div class="input">
              <input
                value="{{ c.apellido }}"
                type="text"
                placeholder="Apellido"
              />
            </div>
          </div>
          <!-- Tipo documento -->
          <div class="input-container">
            <span class="label">Tipo documento</span>
            <div class="input">
              <input
                value="{{ c.tipoDocumento }}"
                type="text"
                placeholder="Tipo documento"
              />
            </div>
          </div>
          <!-- Nro Documento -->
          <div class="input-container">
            <span class="label">Nro Documento</span>
            <div class="input">
              <input
                value="{{ c.nroDocumento }}"
                type="text"
                placeholder="Nro Documento"
              />
            </div>
          </div>
          <!-- Reclamante -->
          <div class="input-container">
            <span class="label">Reclamante</span>
            <div class="input">
              <input
                value="{{ c.reclamante }}"
                type="text"
                placeholder="Reclamante"
              />
            </div>
          </div>
          <!-- Damnificado -->
          <div class="input-container">
            <span class="label">Damnificado</span>
            <div class="input">
              <input
                value="{{ c.damnificado }}"
                type="text"
                placeholder="Damnificado"
              />
            </div>
          </div>
          <!-- Tercero transporte -->
          <div class="input-container">
            <span class="label">Tercero transporte</span>
            <div class="input">
              <input
                value="{{ c.tercero }}"
                type="text"
                placeholder="Tercero transporte"
              />
            </div>
          </div>
          <!-- Descripcion del daño -->
          <div class="input-container textarea">
            <span class="label">Descripción del daño</span>
            <div class="input">
              <textarea
                value="{{ c.descripcion }}"
                placeholder="Descripción del daño"
              ></textarea>
            </div>
          </div>
          <!-- Detalle de archivos -->
          <div class="input-container textarea">
            <span class="label">Detalle de archivos</span>
            <div class="input">
              <textarea
                value="{{ c.detalleArchivos }}"
                placeholder="Detalle de archivos"
              ></textarea>
            </div>
          </div>
          <!-- Direccion del tercero -->
          <div class="input-container">
            <span class="label">Dirección del tercero</span>
            <div class="input">
              <input
                value="{{ c.direccionTercero }}"
                type="text"
                placeholder="Dirección del tercero"
              />
            </div>
          </div>
          <!-- Telefono del tercero -->
          <div class="input-container">
            <span class="label">Teléfono del tercero</span>
            <div class="input">
              <input
                value="{{ c.telefonoTercero }}"
                type="text"
                placeholder="Teléfono del tercero"
              />
            </div>
          </div>

          <!-- Número libreta -->
          <div class="input-container">
            <span class="label">Número libreta</span>
            <div class="input">
              <input
                value="{{ c.numeroLibreta }}"
                type="text"
                placeholder="Número libreta"
              />
            </div>
          </div>
          <!-- Departamento libreta -->
          <div class="input-container">
            <span class="label">Departamento libreta</span>
            <div class="input">
              <input
                value="{{ c.departamentoLibreta }}"
                type="text"
                placeholder="Departamento libreta"
              />
            </div>
          </div>
          <!-- Vencimiento libreta -->
          <div class="input-container">
            <span class="label">Vencimiento libreta</span>
            <div class="input">
              <input
                value="{{ c.vencimientoLibreta }}"
                type="text"
                placeholder="Vencimiento libreta"
              />
              <i class="fas fa-calendar-alt"></i>
            </div>
          </div>
          <!-- Categoría libreta -->
          <div class="input-container">
            <span class="label">Categoría libreta</span>
            <div class="input">
              <input
                value="{{ c.categoriaLibreta }}"
                type="text"
                placeholder="Categoría libreta"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let a of animales" class="div-form">
    <div class="collapsible-container">
      <span (click)="activateTab(a)" [class.active]="a.activeTab"
        ><strong>Animal</strong> - {{ a.nombre
        }}<i *ngIf="a.activeTab" class="fas fa-chevron-up"></i
        ><i *ngIf="!a.activeTab" class="fas fa-chevron-down"></i>
        <span
          class="claimants-status-label"
          [class.procesando]="
            a.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.PROCESANDO.toLowerCase()
          "
          [class.ingresado-sap]="
            a.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.INGRESADO_SAP.toLowerCase()
          "
          [class.en-espera]="
            a.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.EN_ESPERA.toLowerCase()
          "
          [class.fallido]="
            a.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.FALLIDO.toLowerCase()
          "
          >{{ a.estadoDeProceso }}</span
        ></span
      >
      <div class="collapsible-content" *ngIf="a.activeTab">
        <div *ngIf="!!a.errorProcesamiento" class="error-alert-container">
          <div class="alert alert-danger">
            <label>{{ a.errorProcesamiento }}</label>
          </div>
        </div>
        <div class="grid-col-3">
          <!-- Tipo de reclamo -->
          <!-- <div class="input-container">
          <span class="label">Tipo de reclamo</span>
          <div class="input">
            <app-custom-dropdown
              [options]="claimTypes"
              [placeholder]="'Tipo reclamo'"
              formControlName="animalTipoReclamo"
            >
            </app-custom-dropdown>
          </div>
        </div> -->
          <!-- Nivel de danio/lesion -->
          <div class="input-container">
            <span class="label">Nivel de daño/lesión</span>
            <div class="input">
              <input
                value="{{ a.nivelDanio }}"
                type="text"
                placeholder="Nivel de daño/lesión"
              />
            </div>
          </div>
          <!-- Figura -->
          <div class="input-container">
            <span class="label">Figura</span>
            <div class="input">
              <input value="{{ a.figura }}" type="text" placeholder="Figura" />
            </div>
          </div>
        </div>
        <!-- Comentarios -->
        <div class="input-container">
          <span class="label">Comentarios</span>
          <div class="input">
            <textarea
              value="{{ a.comentarios }}"
              placeholder="Comentarios"
            ></textarea>
          </div>
        </div>
        <div class="grid-col-3">
          <!-- Nombre -->
          <div class="input-container">
            <span class="label">Nombre</span>
            <div class="input">
              <input value="{{ a.nombre }}" type="text" placeholder="Nombre" />
            </div>
          </div>
          <!-- Apellido -->
          <div class="input-container">
            <span class="label">Apellido</span>
            <div class="input">
              <input
                value="{{ a.apellido }}"
                type="text"
                placeholder="Apellido"
              />
            </div>
          </div>
          <!-- Tipo documento -->
          <div class="input-container">
            <span class="label">Tipo documento</span>
            <div class="input">
              <input
                value="{{ a.tipoDocumento }}"
                type="text"
                placeholder="Tipo documento"
              />
            </div>
          </div>
          <!-- Nro Documento -->
          <div class="input-container">
            <span class="label">Nro Documento</span>
            <div class="input">
              <input
                value="{{ a.nroDocumento }}"
                type="text"
                placeholder="Nro Documento"
              />
            </div>
          </div>
          <!-- Reclamante -->
          <div class="input-container">
            <span class="label">Reclamante</span>
            <div class="input">
              <input
                value="{{ a.reclamante }}"
                type="text"
                placeholder="Reclamante"
              />
            </div>
          </div>
          <!-- Damnificado -->
          <div class="input-container">
            <span class="label">Damnificado</span>
            <div class="input">
              <input
                value="{{ a.damnificado }}"
                type="text"
                placeholder="Damnificado"
              />
            </div>
          </div>
          <!-- Tercero transporte -->
          <div class="input-container">
            <span class="label">Tercero transporte</span>
            <div class="input">
              <input
                value="{{ a.tercero }}"
                type="text"
                placeholder="Tercero transporte"
              />
            </div>
          </div>
          <!-- Descripcion del danio -->
          <div class="input-container textarea">
            <span class="label">Descripción del daño</span>
            <div class="input">
              <textarea
                value="{{ a.descripcion }}"
                placeholder="Descripción del daño"
              ></textarea>
            </div>
          </div>
          <!-- Detalle de archivos -->
          <div class="input-container textarea">
            <span class="label">Detalle de archivos</span>
            <div class="input">
              <textarea
                value="{{ a.detalleArchivos }}"
                placeholder="Detalle de archivos"
              ></textarea>
            </div>
          </div>
          <!-- Compania del tercero -->
          <div class="input-container">
            <span class="label">Compañía del tercero</span>
            <div class="input">
              <input
                value="{{ a.companiaTercero }}"
                type="text"
                placeholder="Compañía del tercero"
              />
            </div>
          </div>
          <!-- Ramo del tercero damnificado -->
          <div class="input-container">
            <span class="label">Ramo del tercero damnificado</span>
            <div class="input">
              <input
                value="{{ a.ramoTerceroDamnificado }}"
                type="text"
                placeholder="Ramo del tercero damnificado"
              />
            </div>
          </div>
          <!-- Telefono del tercero -->
          <div class="input-container">
            <span class="label">Teléfono del tercero</span>
            <div class="input">
              <input
                value="{{ a.telefonoTercero }}"
                type="text"
                placeholder="Teléfono del tercero"
              />
            </div>
          </div>
          <!-- Direccion del tercero -->
          <div class="input-container">
            <span class="label">Dirección del tercero</span>
            <div class="input">
              <input
                value="{{ a.direccionTercero }}"
                type="text"
                placeholder="Dirección del tercero"
              />
            </div>
          </div>
          <!-- Número libreta -->
          <div class="input-container">
            <span class="label">Número libreta</span>
            <div class="input">
              <input
                value="{{ a.numeroLibreta }}"
                type="text"
                placeholder="Número libreta"
              />
            </div>
          </div>
          <!-- Departamento libreta -->
          <div class="input-container">
            <span class="label">Departamento libreta</span>
            <div class="input">
              <input
                value="{{ a.departamentoLibreta }}"
                type="text"
                placeholder="Departamento libreta"
              />
            </div>
          </div>
          <!-- Vencimiento libreta -->
          <div class="input-container">
            <span class="label">Vencimiento libreta</span>
            <div class="input">
              <input
                value="{{ a.vencimientoLibreta }}"
                type="text"
                placeholder="Vencimiento libreta"
              />
              <i class="fas fa-calendar-alt"></i>
            </div>
          </div>
          <!-- Categoría libreta -->
          <div class="input-container">
            <span class="label">Categoría libreta</span>
            <div class="input">
              <input
                value="{{ a.categoriaLibreta }}"
                type="text"
                placeholder="Categoría libreta"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let p of personas" class="div-form">
    <div class="collapsible-container">
      <span (click)="activateTab(p)" [class.active]="p.activeTab"
        ><strong>Persona</strong> - {{ p.nombre }} {{ p.apellido
        }}<i *ngIf="p.activeTab" class="fas fa-chevron-up"></i
        ><i *ngIf="!p.activeTab" class="fas fa-chevron-down"></i>
        <span
          class="claimants-status-label"
          [class.procesando]="
            p.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.PROCESANDO.toLowerCase()
          "
          [class.ingresado-sap]="
            p.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.INGRESADO_SAP.toLowerCase()
          "
          [class.en-espera]="
            p.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.EN_ESPERA.toLowerCase()
          "
          [class.fallido]="
            p.estadoDeProceso.toLowerCase() ==
            estadoReclamantesSAP.FALLIDO.toLowerCase()
          "
          >{{ p.estadoDeProceso }}</span
        ></span
      >
      <div class="collapsible-content" *ngIf="p.activeTab">
        <div *ngIf="!!p.errorProcesamiento" class="error-alert-container">
          <div class="alert alert-danger">
            <label>{{ p.errorProcesamiento }}</label>
          </div>
        </div>
        <div class="grid-col-3">
          <!-- Nivel de danio/lesion -->
          <div class="input-container">
            <span class="label">Nivel de daño/lesión</span>
            <div class="input">
              <input
                value="{{ p.nivelDanio }}"
                type="text"
                placeholder="Nivel de daño/lesión"
              />
            </div>
          </div>
          <!-- Figura -->
          <div class="input-container">
            <span class="label">Figura</span>
            <div class="input">
              <input value="{{ p.figura }}" type="text" placeholder="Figura" />
            </div>
          </div>
        </div>
        <!-- Comentarios -->
        <div class="input-container">
          <span class="label">Comentarios</span>
          <div class="input">
            <textarea
              value="{{ p.comentarios }}"
              placeholder="Comentarios"
            ></textarea>
          </div>
        </div>
        <div class="grid-col-3">
          <!-- Nombre -->
          <div class="input-container">
            <span class="label">Nombre</span>
            <div class="input">
              <input value="{{ p.nombre }}" type="text" placeholder="Nombre" />
            </div>
          </div>
          <!-- Apellido -->
          <div class="input-container">
            <span class="label">Apellido</span>
            <div class="input">
              <input
                value="{{ p.apellido }}"
                type="text"
                placeholder="Apellido"
              />
            </div>
          </div>
          <!-- Tipo documento -->
          <div class="input-container">
            <span class="label">Tipo documento</span>
            <div class="input">
              <input
                value="{{ p.tipoDocumento }}"
                type="text"
                placeholder="Tipo documento"
              />
            </div>
          </div>
          <!-- Nro Documento -->
          <div class="input-container">
            <span class="label">Nro Documento</span>
            <div class="input">
              <input
                value="{{ p.nroDocumento }}"
                type="text"
                placeholder="Nro Documento"
              />
            </div>
          </div>
          <!-- Reclamante -->
          <div class="input-container">
            <span class="label">Reclamante</span>
            <div class="input">
              <input
                value="{{ p.reclamante }}"
                type="text"
                placeholder="Reclamante"
              />
            </div>
          </div>
          <!-- Damnificado -->
          <div class="input-container">
            <span class="label">Damnificado</span>
            <div class="input">
              <input
                value="{{ p.damnificado }}"
                type="text"
                placeholder="Damnificado"
              />
            </div>
          </div>
          <!-- Tercero transporte -->
          <div class="input-container">
            <span class="label">Tercero transporte</span>
            <div class="input">
              <input
                value="{{ p.tercero }}"
                type="text"
                placeholder="Tercero transporte"
              />
            </div>
          </div>
          <!-- Detalle de archivos -->
          <div class="input-container textarea">
            <span class="label">Detalle de archivos</span>
            <div class="input">
              <textarea
                value="{{ p.detalleArchivos }}"
                placeholder="Detalle de archivos"
              ></textarea>
            </div>
          </div>
          <!-- Relacion con el asegurado -->
          <div class="input-container">
            <span class="label">Relación con el asegurado</span>
            <div class="input">
              <input
                value="{{ p.relacionConElAsegurado }}"
                type="text"
                placeholder="Relación con el asegurado"
              />
            </div>
          </div>
          <!-- Relacion con el conductor -->
          <div class="input-container">
            <span class="label">Relación con el conductor</span>
            <div class="input">
              <input
                value="{{ p.relacionConductor }}"
                type="text"
                placeholder="Relación con el conductor"
              />
            </div>
          </div>
          <!-- Prestó la primer atención -->
          <div class="input-container">
            <span class="label">Prestó la primer atención</span>
            <div class="input">
              <input
                value="{{ p.prestoPrimerAtencion }}"
                type="text"
                placeholder="Prestó la primer atención"
              />
            </div>
          </div>
          <!-- Derivó al Centro Asistencial -->
          <div class="input-container">
            <span class="label">Derivó al Centro Asistencial</span>
            <div class="input">
              <input
                value="{{ p.derivoCentroAsistencial }}"
                type="text"
                placeholder="Derivó al Centro Asistencial"
              />
            </div>
          </div>
          <!-- Centro asistencial -->
          <div class="input-container">
            <span class="label">Centro Asistencial</span>
            <div class="input">
              <input
                value="{{ p.centroAsistencial }}"
                type="text"
                placeholder="Centro Asistencial"
              />
            </div>
          </div>
          <!-- Compania del tercero -->
          <div class="input-container">
            <span class="label">Compañía del tercero</span>
            <div class="input">
              <input
                value="{{ p.companiaTercero }}"
                type="text"
                placeholder="Compañía del tercero"
              />
            </div>
          </div>
          <!-- Ramo del tercero damnificado -->
          <div class="input-container">
            <span class="label">Ramo del tercero damnificado</span>
            <div class="input">
              <input
                value="{{ p.ramoTerceroDaminificado }}"
                type="text"
                placeholder="Ramo del tercero damnificado"
              />
            </div>
          </div>
          <!-- Telefono del tercero -->
          <div class="input-container">
            <span class="label">Teléfono del tercero</span>
            <div class="input">
              <input
                value="{{ p.telefonoTercero }}"
                type="text"
                placeholder="Teléfono del tercero"
              />
            </div>
          </div>
          <!-- Direccion del tercero -->
          <div class="input-container">
            <span class="label">Dirección del tercero</span>
            <div class="input">
              <input
                value="{{ p.direccionTercero }}"
                type="text"
                placeholder="Dirección del tercero"
              />
            </div>
          </div>
          <!-- Número libreta -->
          <div class="input-container">
            <span class="label">Número libreta</span>
            <div class="input">
              <input
                value="{{ p.numeroLibreta }}"
                type="text"
                placeholder="Número libreta"
              />
            </div>
          </div>
          <!-- Departamento libreta -->
          <div class="input-container">
            <span class="label">Departamento libreta</span>
            <div class="input">
              <input
                value="{{ p.departamentoLibreta }}"
                type="text"
                placeholder="Departamento libreta"
              />
            </div>
          </div>
          <!-- Vencimiento libreta -->
          <div class="input-container">
            <span class="label">Vencimiento libreta</span>
            <div class="input">
              <input
                value="{{ p.vencimientoLibreta }}"
                type="text"
                placeholder="Vencimiento libreta"
              />
              <i class="fas fa-calendar-alt"></i>
            </div>
          </div>
          <!-- Categoría libreta -->
          <div class="input-container">
            <span class="label">Categoría libreta</span>
            <div class="input">
              <input
                value="{{ p.categoriaLibreta }}"
                type="text"
                placeholder="Categoría libreta"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
